import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.instagram.com/initial_gr"
        className="home__social-icon"
        target="_blank"
      >
        <i class="uil uil-instagram"></i>
      </a>
      <a
        href="https://wa.me/message/4B4KRFF7GCPSH1"
        className="home__social-icon"
        target="_blank"
      >
        <i class="uil uil-whatsapp"></i>
      </a>
      <a
        href="https://www.github.com/initialgr"
        className="home__social-icon"
        target="_blank"
      >
        <i class="uil uil-github"></i>
      </a>
    </div>
  );
};

export default Social;
